<style>
	.total-company-name{
		margin:1em 0 .5em 1em;
	}
	.total-company-date{
		margin:0.5em 1em;
	}
	.total-company-p{
		margin:0;
		margin-left:3em;
	}
	.total-company-p:last-child{
		margin-bottom: 1em;
	}
	.total-company-ul{
		float: left;
		width: 100%;
		margin-left: 5%;
	}
	.total-company-ul li{
		float: left;
		width: 50%;
		font-size: 16px;
	}
</style>
<template>
	<div>
		<transition name="totalSlide">
			<div class="billcount-detail-total" v-show="shown" @click="moveAni" style="background:#fff">
				<p class="total-company-name"><strong>{{totalSum.restaurant_name}}</strong></p>
				<p class="total-company-date">
					<span v-if="filter.date_type === '0'">订货日期：</span>
					<span v-if="filter.date_type === '1'">到货日期：</span>
					{{totalSum.startDate}} 到 {{totalSum.endDate}}
				</p>
				<ul class="total-company-ul">
					<li v-if="goods_num">订货金额合计：{{sub_total}} 元</li>
					<li v-if="goods_num">订货数量合计：{{goods_num}} </li>
					<li v-if="goods_num_send">发货金额合计：{{sub_total_send}} 元</li>
					<li v-if="goods_num_send">发货数量合计：{{goods_num_send}} </li>
					<li v-if="goods_num_recipient">收货金额合计：{{sub_total_recipient}} 元</li>
					<li v-if="goods_num_recipient">收货数量合计：{{goods_num_recipient}} </li>
					<li v-if="return_sub_total">退货金额合计：{{return_sub_total}} 元</li>
					<li v-if="return_sub_total">退货数量合计：{{return_num_total}} </li>
				</ul>
				<!-- <p class="total-company-p" v-if="goods_num">订货金额合计：{{goods_num}} 元</p>
				<p class="total-company-p" v-if="goods_num_send">发货金额合计：{{goods_num_send}} 元</p>
				<p class="total-company-p" v-if="sub_total">收货金额合计：{{sub_total}} 元</p>
				<p class="total-company-p" v-if="return_sub_total">退货金额合计：{{return_sub_total}} 元</p> -->
			</div>
		</transition>
		<div class="edi-total-second" v-show="!shown" @click="getTotal">合计</div>
	</div>
</template>
<script>
export default {
	props: {
		filter: {},
		href: String,
		name: String
	},
	data () {
		return {
			shown: false,
			billState: 0,
			sub_total_recipient: 0, // 收货金额合计
			sub_total_send: 0, // 发货金额合计
			sub_total: 0, // 订货金额合计
			return_sub_total: 0, // 退货金额合计
			goods_num: 0, // 订货数量合计
			goods_num_send: 0, // 发货数量合计
			goods_num_recipient: 0, // 收货数量合计
			return_num_total: 0, // 退货数量合计
			bill_state: '',
			totalSum: {}
		}
	},
	methods: {
		close () {
			this.shown = false
		},
		getTotal () {
			var val = this.href
			// window.console.log(this.filter)
			this.$http.post(val, this.filter).then((response) => {
				if (response.body.result) {
					this.shown = !this.shown
					this.totalSum = response.body.data
					this.billState = this.totalSum.details[0].bill_state
					window.console.log(typeof (this.billState))
					this.sub_total = this.totalSum.details[0].sub_total // 订货金额合计
					this.goods_num = this.totalSum.details[0].goods_num // 订货数量合计
					this.sub_total_send = this.totalSum.details[0].sub_total_send // 发货金额合计
					this.goods_num_send = this.totalSum.details[0].goods_num_send // 发货数量合计
					this.sub_total_recipient = this.totalSum.details[0].sub_total_recipient // 收货金额合计
					this.goods_num_recipient = this.totalSum.details[0].goods_num_recipient // 收货数量合计
					this.return_sub_total = this.totalSum.details[0].return_sub_total // 退货金额合计
					this.return_num_total = this.totalSum.details[0].return_num_total // 退货数量合计
				}
			})
		},
		moveAni () {
			this.shown = !this.shown
		}
	}
}
</script>


// WEBPACK FOOTER //
// GetCompanyTotal.vue?59ee84c6